import React from 'react';

import CenteredContainer from 'components/CenteredContainer';
import OrganizationNavigationMenu from 'screens/organizations/components/OrganizationNavigationMenu';

interface Props {
  children?: JSX.Element;
  isAdmin: boolean;
  isUserMember?: boolean;
  hidePageMenu?: boolean;
  autoCenterContent?: boolean;
}
function PageLayout({
  children,
  hidePageMenu = false,
  isAdmin,
  isUserMember,
  autoCenterContent = true
}: Props) {
  const navigationMenu = (
    <>
      {!hidePageMenu && (
        <OrganizationNavigationMenu
          isAdmin={isAdmin}
          isUserMember={isUserMember}
        />
      )}
    </>
  );

  if (autoCenterContent) {
    return (
      <div className="min-h-[500px]">
        <CenteredContainer wideContent>
          {navigationMenu}
          <div>{children}</div>
        </CenteredContainer>
      </div>
    );
  }

  return (
    <div>
      <CenteredContainer wideContent>{navigationMenu}</CenteredContainer>
      {children}
    </div>
  );
}

export default PageLayout;
